module.exports = __webpack_public_path__ + "media/images/clients/user_white-b5695e225647878c5b1296fd1c7c31a2.png";